import { removePropertyEmpty } from '@/utils/index'
import { Service } from '../config'

class IntegrationService extends Service {
  path = 'gerenciadorIntegracoes'
  async getIntegrations(params?: any) {
    const httpResponse = await this.httpClient.get(this.path, {
      params: removePropertyEmpty(params)
    })
    return httpResponse
  }
}

export const integrationService = new IntegrationService()
